export function OnboardingConceptBox({ icon: Icon, children }) {
  return (
    <div className="onboarding-surface flex gap-space-3 rounded-ds-lg p-space-4">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-md bg-card text-sage-600 dark:text-sage-400">
        <Icon className="h-5 w-5" aria-hidden />
      </span>
      <p className="type-body-sm leading-snug text-muted-foreground">{children}</p>
    </div>
  );
}
